import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import ModalTrigger from '../../common/ModalTrigger';
import { putRequest, getRequest } from '../../../requestUtils';
import DropdownIndicator from '../../common/DropdownIndicator';
import customStyles from '../../../dropdownStyleUtils';
import TextAreaInput from '../../common/TextAreaInput';
import './ResumeActions.scss';
var submitDisabled = function submitDisabled(action, internalFeedbacks, feedbackText, message) {
  return feedbackText.length === 0 || action === 'Decline' && (message.length === 0 || internalFeedbacks.length === 0 || internalFeedbacks && internalFeedbacks.map(function (r) {
    return r.label;
  }).includes('Other') && feedbackText === '');
};
var internalFeedbackOptions = function internalFeedbackOptions() {
  return getRequest('/internal_feedbacks/').then(function (response) {
    return response.data.map(function (i) {
      return {
        label: i.name,
        value: i.id
      };
    });
  });
};
var ResumeActions = /*#__PURE__*/function (_Component) {
  function ResumeActions(props) {
    var _this;
    _classCallCheck(this, ResumeActions);
    _this = _callSuper(this, ResumeActions, [props]);
    _this.state = {
      message: _this.templateMessage(),
      internalFeedbacks: props.internalFeedbacks,
      feedbackText: props.feedbackText,
      sendEmail: true
    };
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _inherits(ResumeActions, _Component);
  return _createClass(ResumeActions, [{
    key: "handleInputChange",
    value: function handleInputChange(name, value) {
      this.setState(_defineProperty({}, name, value));
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this$props = this.props,
        action = _this$props.action,
        formUrl = _this$props.formUrl,
        csrfToken = _this$props.csrfToken,
        afterSubmit = _this$props.afterSubmit,
        interestId = _this$props.interestId;
      var _this$state = this.state,
        message = _this$state.message,
        internalFeedbacks = _this$state.internalFeedbacks,
        feedbackText = _this$state.feedbackText,
        sendEmail = _this$state.sendEmail;
      var params = {
        rep_action: action.toLowerCase(),
        id: interestId,
        send_email: sendEmail,
        message: message,
        internal_feedback_ids: internalFeedbacks.map(function (r) {
          return r.value;
        }),
        internal_feedback_text: feedbackText
      };
      putRequest(formUrl, params, csrfToken).then(function (response) {
        afterSubmit(response.data);
      });
    }
  }, {
    key: "actionVerb",
    value: function actionVerb() {
      var action = this.props.action;
      switch (action) {
        case 'Decline':
          return 'declining';
        case 'Waitlist':
          return 'waitlisting';
        case 'Accept':
          return 'accepting';
        default:
          return null;
      }
    }
  }, {
    key: "templateMessage",
    value: function templateMessage() {
      var _this$props2 = this.props,
        action = _this$props2.action,
        responseTemplates = _this$props2.responseTemplates;
      return responseTemplates[action.toLowerCase()] || null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        consultant = _this$props3.consultant,
        project = _this$props3.project,
        action = _this$props3.action,
        addlButtonStyle = _this$props3.addlButtonStyle;
      var _this$state2 = this.state,
        message = _this$state2.message,
        internalFeedbacks = _this$state2.internalFeedbacks,
        feedbackText = _this$state2.feedbackText,
        sendEmail = _this$state2.sendEmail;
      var placeholder = internalFeedbacks && internalFeedbacks.map(function (r) {
        return r.label;
      }).includes('Other') ? 'Explanation (required)' : 'Explanation';
      var buttonStyles = '';
      switch (action) {
        case 'Accept':
          buttonStyles = 'primary btn btn-primary accept-resume-button';
          break;
        case 'Decline':
          buttonStyles = 'btn btn-danger decline-resume-button';
          break;
        case 'Waitlist':
          buttonStyles = 'secondary btn btn-secondary';
          break;
        default:
      }
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: action,
        buttonStyles: "".concat(buttonStyles, " ").concat(addlButtonStyle),
        submitButtonText: action,
        handleSubmit: this.handleSubmit,
        triggerType: "button",
        idKey: "".concat(action.toLowerCase(), "-resume"),
        submitDisabled: submitDisabled(action, internalFeedbacks, feedbackText, message),
        closeAfterSubmit: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "style-guide"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-center mb-3"
      }, /*#__PURE__*/React.createElement("h1", null, "You're about to ".concat(action.toLowerCase(), " ").concat(consultant, " for the ").concat(project, "!"))), "Indicate primary reason(s) you are", ' ', this.actionVerb(), ' ', "this consultant's interest:", /*#__PURE__*/React.createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/React.createElement(AsyncSelect, {
        className: "rejection-dropdown",
        styles: customStyles,
        classNamePrefix: "clora-multiselect",
        loadOptions: internalFeedbackOptions,
        defaultOptions: true,
        value: internalFeedbacks,
        maxMenuHeight: 500,
        onChange: function onChange(val) {
          return _this2.handleInputChange('internalFeedbacks', val);
        },
        closeOnSelect: false,
        closeMenuOnSelect: false,
        isMulti: true,
        cacheOptions: true,
        components: {
          DropdownIndicator: DropdownIndicator,
          IndicatorSeparator: function IndicatorSeparator() {
            return null;
          }
        }
      })), "Internal notes about", ' ', action === 'Accept' ? 'accepted interest' : action.toLowerCase(), ":", /*#__PURE__*/React.createElement("div", {
        className: "action-explanation mb-25"
      }, /*#__PURE__*/React.createElement(TextAreaInput, {
        textAreaPrompt: "",
        placeholder: placeholder,
        value: feedbackText,
        onAnswerChange: function onAnswerChange(val) {
          return _this2.handleInputChange('feedbackText', val);
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "option consultant-email-option-container d-flex gap-3 my-3"
      }, /*#__PURE__*/React.createElement("span", {
        className: "consultant-email-option-heading"
      }, "Do you want to send an email?"), /*#__PURE__*/React.createElement("label", {
        className: "custom-radio-container mr-15",
        htmlFor: "email"
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        id: "email",
        name: "email",
        value: true,
        checked: sendEmail,
        onChange: function onChange() {
          return _this2.setState({
            sendEmail: true
          });
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "radio-btn radio-btn-red"
      }), /*#__PURE__*/React.createElement("span", {
        className: "radio-text"
      }, "Yes")), /*#__PURE__*/React.createElement("label", {
        className: "custom-radio-container",
        htmlFor: "no-email"
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        id: "no-email",
        name: "no-email",
        value: false,
        checked: !sendEmail,
        onChange: function onChange() {
          return _this2.setState({
            sendEmail: false
          });
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "radio-btn radio-btn-red"
      }), /*#__PURE__*/React.createElement("span", {
        className: "radio-text"
      }, "No"))), sendEmail && /*#__PURE__*/React.createElement("div", {
        className: "rejection-email-text"
      }, /*#__PURE__*/React.createElement(TextAreaInput, {
        textAreaPrompt: "",
        placeholder: "Email message",
        onAnswerChange: function onAnswerChange(val) {
          return _this2.handleInputChange('message', val);
        },
        value: message
      }))));
    }
  }]);
}(Component);
ResumeActions.propTypes = {
  consultant: PropTypes.string.isRequired,
  project: PropTypes.string.isRequired,
  formUrl: PropTypes.string.isRequired,
  interestId: PropTypes.number.isRequired,
  csrfToken: PropTypes.string.isRequired,
  responseTemplates: PropTypes.shape({
    accept: PropTypes.string,
    decline: PropTypes.string,
    waitlist: PropTypes.string
  }).isRequired,
  afterSubmit: PropTypes.func.isRequired,
  internalFeedbacks: PropTypes.arrayOf(PropTypes.string),
  feedbackText: PropTypes.string,
  action: PropTypes.oneOf(['Accept', 'Decline', 'Waitlist']).isRequired,
  addlButtonStyle: PropTypes.string
};
ResumeActions.defaultProps = {
  internalFeedbacks: [],
  feedbackText: '',
  addlButtonStyle: ''
};
export default ResumeActions;